export default __webpack_public_path__ + "static/media/Visa.5c23491e.png";